// Fase 2 (W11): Meus assistentes, Aprovar ação, passkeys, painel de uso, lixeira e nível por papel (pt).
export const assistentesPt = {
  // Lote 19/10: tela de consentimento do OAuth do MCP.
  oauth: {
    kicker: 'Conexão por OAuth',
    titulo: 'Autorizar acesso ao MalgoOS',
    pedido: '{{cliente}} quer acessar o MalgoOS em seu nome',
    cliente: 'Cliente',
    volta: 'Volta para',
    registrado: 'Registrado em',
    workspace: 'Workspace',
    empresa: 'Empresa',
    todas: 'Todas as empresas que você vê',
    escopos: 'O que o cliente pode fazer',
    escoposAjuda: 'Nunca mais do que você pode. As escritas sensíveis esperam a sua confirmação, como nos assistentes, e papéis, chaves e configurações ficam só com você.',
    assistente: 'A conexão aparece em Minha conta > Meus assistentes, onde você vê o que ela fez e pode revogar.',
    desligado: 'A conexão por OAuth está desligada neste workspace. Peça a quem administra para permitir em Integrações > MCP.',
    aprovar: 'Autorizar',
    recusar: 'Recusar',
    autorizado: 'Acesso autorizado',
    recusado: 'Acesso recusado',
    voltando: 'Voltando para {{cliente}}...',
    erroTitulo: 'Não foi possível autorizar',
    erros: {
      cliente_invalido: 'Cliente desconhecido. Comece de novo pelo aplicativo que pediu o acesso.',
      redirect_invalido: 'O endereço de volta não é o que o cliente registrou. Por segurança, o acesso não foi liberado.',
      pedido_invalido: 'Pedido de autorização inválido. Comece de novo pelo aplicativo que pediu o acesso.',
    },
  },
  aba: 'Meus assistentes',
  titulo: 'Meus assistentes',
  texto: 'Seu assistente de IA trabalha em seu nome, com no máximo as suas permissões. O que é reversível ele faz direto; o que é sensível ele prepara e espera a sua confirmação; papéis, chaves e configurações ele nunca mexe.',
  novo: 'Novo assistente',
  vazioTitulo: 'Você ainda não tem assistente',
  vazioTexto: 'Crie um assistente, escolha os módulos e os limites e use a chave dele no seu agente (MCP).',
  escopoTodos: 'Todos os módulos que você acessa',
  semChave: 'Sem chave ativa',
  nunca: 'Nunca',
  semLimiteCurto: 'Sem teto',
  qualquerHora: 'Qualquer hora',
  verAtividade: 'O que ele fez',
  novaChave: 'Nova chave',
  reativar: 'Reativar',
  revogar: 'Revogar',
  revogado: 'Assistente revogado',
  reativado: 'Assistente reativado',
  suspenso: 'Assistente suspenso. Reative quando quiser que ele volte a trabalhar.',
  suspensoAnomalia: 'Suspenso pelo alerta de comportamento fora do padrão (exclusões demais em pouco tempo). Confira o que ele fez antes de reativar.',
  revogarTitulo: 'Revogar {{nome}}?',
  revogarTexto: 'A chave para de valer na hora e as ações que esperam a sua confirmação expiram. Não dá para desfazer.',
  novaChaveTitulo: 'Gerar nova chave?',
  novaChaveTexto: 'A chave atual para de valer na hora. Troque a chave no seu agente em seguida.',
  estados: { ativo: 'Ativo', suspenso: 'Suspenso', revogado: 'Revogado' },
  estadosAprovacao: { pendente: 'Aguardando você', aprovada: 'Aprovada', recusada: 'Recusada', expirada: 'Expirada', falhou: 'Não concluída' },
  campos: {
    chave: 'Chave',
    ultimoUso: 'Último uso',
    hoje: 'Ações hoje',
    deLimite: '{{n}} de {{limite}}',
    pendentes: 'Esperando você',
    valorMaximo: 'Teto por operação',
    horario: 'Horário',
  },
  niveis: { n1: 'faz direto', n2: 'pede sua confirmação', n3: 'nunca faz' },
  dias: { 0: 'Dom', 1: 'Seg', 2: 'Ter', 3: 'Qua', 4: 'Qui', 5: 'Sex', 6: 'Sáb' },
  chave: {
    titulo: 'Chave do assistente',
    copiar: 'Copiar chave',
    guardei: 'Já guardei',
    texto: 'Esta é a única vez em que a chave aparece. Guarde no seu agente agora; se perder, gere uma nova.',
    como: 'No agente, use o servidor MCP em {{url}} com o cabeçalho Authorization: Bearer seguido da chave.',
  },
  form: {
    editar: 'Editar {{nome}}',
    criar: 'Criar assistente',
    nome: 'Nome',
    nomeAjuda: 'Como você chama o seu assistente (por exemplo, Oliv).',
    escopo: 'O que ele pode acessar',
    escopoTexto: 'Ele nunca passa das suas permissões. Escolha só o que ele precisa.',
    todos: 'Todos os módulos que eu acesso',
    semAcesso: 'Sem acesso',
    leitura: 'Só leitura',
    escrita: 'Leitura e escrita',
    escolhaModulo: 'Escolha ao menos um módulo',
    confirmacao: 'Confirmação',
    confirmarTudo: 'Pedir minha confirmação também nas ações reversíveis',
    prazo: 'Prazo para eu confirmar',
    horas_one: '{{count}} hora',
    horas_other: '{{count}} horas',
    niveisTitulo: 'O que ele faz sozinho e o que pede confirmação',
    niveisTexto: 'Pelo seu papel. Excluir, mexer em dinheiro, dado pessoal e envio externo pedem a sua confirmação; o que é reservado só você faz, direto na tela.',
    nenhumaAcao: 'Nenhuma ação sua neste nível.',
    limites: 'Limites',
    acoesPorDia: 'Ações por dia',
    semLimite: 'Em branco, sem teto.',
    valorMaximo: 'Valor máximo por operação financeira',
    valorInvalido: 'Valor inválido',
    horarioInicio: 'Pode trabalhar a partir de',
    horarioFim: 'Até',
    horarioIncompleto: 'Informe o início e o fim, ou nenhum dos dois',
    dias: 'Dias permitidos',
    diasAjuda: 'Nenhum marcado, todos os dias.',
    anomaliaExclusoes: 'Alerta: exclusões',
    anomaliaJanela: 'Em quantos minutos',
    anomaliaAjuda: 'Passado esse número de exclusões na janela, o assistente é suspenso e você recebe um aviso.',
  },
  atividade: { vazio: 'Ele ainda não fez nada.', aprovada: 'Aprovada por você' },
  pendentes: {
    titulo_one: '{{count}} ação esperando a sua confirmação',
    titulo_other: '{{count}} ações esperando a sua confirmação',
    linha: '{{assistente}}: {{acao}} em {{modulo}}',
    expira: 'Expira em {{data}}',
    revisar: 'Revisar',
  },
  uso: {
    titulo: 'Uso do assistente',
    texto: 'De {{de}} a {{ate}}. Conta o que os assistentes fizeram em seu nome e o que você fez direto na tela.',
    pessoa: 'Pessoa',
    eu: '{{nome}} (você)',
    vazioTitulo: 'Sem uso no período',
    vazioTexto: 'Quando o assistente trabalhar, os números aparecem aqui.',
    acionamentos: 'Acionamentos',
    feitas: 'Ações feitas por ele',
    preparadas: 'Ações preparadas',
    pendentesAgora_one: '{{count}} esperando agora',
    pendentesAgora_other: '{{count}} esperando agora',
    tempoMedio: 'Tempo até a confirmação',
    aprovadas: 'Aprovadas',
    falharam_one: '{{count}} não concluída',
    falharam_other: '{{count}} não concluídas',
    recusadas: 'Recusadas',
    expiradas: 'Expiradas',
    viaAssistente: 'Pelo assistente',
    viaDetalhe: '{{via}} pelo assistente, {{direto}} direto na tela',
    semDado: 'Sem dado',
    modulos: 'Módulos mais usados pelo assistente',
    semModulos: 'Nenhuma alteração pelo assistente no período.',
    segundos: '{{n}} s',
    minutos: '{{n}} min',
    horas: '{{n}} h',
  },
  lixeira: {
    titulo: 'Desfazer o que o assistente excluiu',
    texto: 'Exclusões dos seus assistentes nos últimos 30 dias. Desfazer volta o registro como estava.',
    vazioTitulo: 'Nada para desfazer',
    vazioTexto: 'O que o assistente excluir aparece aqui por 30 dias.',
    ate: 'Dá para desfazer até {{data}}',
    desfazer: 'Desfazer',
    restaurado: 'Registro de volta',
  },
  passkeys: {
    titulo: 'Passkeys',
    texto: 'A passkey confirma as ações sensíveis do seu assistente com a biometria do seu aparelho (Face ID, Touch ID ou digital). O MalgoOS não guarda a sua biometria.',
    nova: 'Nova passkey',
    novaTexto: 'Dê um nome ao aparelho e confirme com a sua senha. Em seguida, o aparelho pede a biometria.',
    criar: 'Criar passkey',
    nome: 'Nome do aparelho',
    nomeAjuda: 'Por exemplo, Celular ou Notebook.',
    cadastrada: 'Passkey criada',
    cancelada: 'A passkey não foi confirmada no aparelho. Tente de novo.',
    semSuporte: 'Este navegador não aceita passkey. Use o código do app autenticador para confirmar.',
    vazioTitulo: 'Nenhuma passkey',
    vazioTexto: 'Crie uma passkey para aprovar com um toque o que o seu assistente preparar.',
    criadaEm: 'Criada em {{data}}',
    usadaEm: 'usada em {{data}}',
    remover: 'Remover',
    removerNome: 'Remover a passkey {{nome}}',
    removerTitulo: 'Remover a passkey {{nome}}?',
    removerTexto: 'Este aparelho deixa de confirmar as ações do assistente.',
    removida: 'Passkey removida',
  },
  aprovar: {
    kicker: 'Assistente',
    titulo: 'Aprovar ação',
    pedido: '{{assistente}} pede a sua confirmação',
    modulo: 'Módulo',
    acao: 'Ação',
    valor: 'Valor',
    registro: 'Registro',
    pedidoEm: 'Pedida em',
    expiraEm: 'Expira em',
    decididaEm: 'Decidida em',
    rota: 'Rota',
    dados: 'O que será feito',
    semDados: 'Sem dados além do registro.',
    feita: 'Ação aprovada e feita',
    feitaTexto: 'Foi feita por {{assistente}} em seu nome e está na auditoria.',
    falhou: 'Aprovada, mas não concluída',
    falhouTexto: 'Nada foi gravado.',
    recusada: 'Ação recusada',
    recusadaTexto: 'Nada foi feito.',
    expirada: 'O prazo venceu',
    expiradaTexto: 'A ação não foi feita. Peça de novo ao assistente se ainda precisar.',
    semPasskey: 'Nenhuma passkey cadastrada. Crie uma em Minha conta, Segurança, ou use o código do app.',
    semConfirmacao: 'Para aprovar, crie uma passkey ou ative a verificação em duas etapas.',
    irSeguranca: 'Ir para Segurança',
    recusar: 'Recusar',
    usarCodigo: 'Usar código do app',
    aprovarCodigo: 'Aprovar com o código',
    aprovarPasskey: 'Aprovar com passkey',
    recusarTitulo: 'Recusar a ação?',
    recusarTexto: '{{assistente}} não vai fazer esta ação.',
    naoEncontrada: 'Aprovação não encontrada',
    naoEncontradaTexto: 'Ela não existe ou é de outra pessoa.',
    irAssistentes: 'Ir para Meus assistentes',
  },
  papel: {
    titulo: 'Nível de risco para os assistentes',
    texto: 'Vale para os assistentes de quem tem este papel. Cada pessoa pode endurecer o próprio assistente, nunca afrouxar.',
    travado: 'Reservado à pessoa (N3)',
    fabrica: 'Fábrica ({{nivel}})',
  },
};
